export default "__VITE_ASSET__Dz5eeQ5Z__"